import { Scene } from '@babylonjs/core';
import { BirdsEyeStage } from './BirdsEyeStage';
import { AJingziStage } from './AJingziStage';
import { BZhuanziStage } from './BZhuanziStage';
import { CLianheStage } from './CLianheStage';
import { DPentuStage } from './DPentuStage';
import { EPeisongStage } from './EPeisongStage';
import { FZongzhuangStage } from './FZongzhuangStage';
import { BaseStage } from './BaseStage';
import { Equipment } from './Equipment';
import { CrossEvent } from './../event/CrossEvent';
import { GlobalObject } from '../utils/GlobalObject';
import { Boardcaster } from '../event/Boadcaster';

export class StageManager {
  private scene: Scene;
  private birdsEyeStage: BirdsEyeStage;
  private ajzStage?: AJingziStage;
  private bzzStage?: BZhuanziStage;
  private clhStage?: CLianheStage;
  private dptStage?: DPentuStage;
  private epsStage?: EPeisongStage;
  private fzzStage?: FZongzhuangStage;
  private nowStage?: BaseStage;
  private equipment?: Equipment;
  private emitter = CrossEvent.getInstance().getEmitter();

  constructor(scene: Scene) {
    this.scene = scene;
    this.loadCamData();
    this.birdsEyeStage = new BirdsEyeStage(this.scene);
    this.nowStage = this.birdsEyeStage;

    this.emitter.on(CrossEvent.getInstance().STAGE_CHANGED, this.onChangeStage.bind(this));
    this.emitter.on(CrossEvent.getInstance().OPEN_EQUIPMENT, this.onOpenEquipment.bind(this));
    // 测试代码
    const temp = GlobalObject.getInstance().main.temp as any;
    temp.changeStage = this.changeStage.bind(this);
  }
  private async loadCamData() {
    const response = await fetch('resources/camdata.json');
    const camData = await response.json();
    GlobalObject.getInstance().setCamdata(camData.data);
    // console.log(camData);
  }
  private onChangeStage(evt: any) {
    this.changeStage(evt.data);
  }
  public changeStage(p: string) {
    console.log(p); // ohp_0 ~ ohp_5
    switch (p) {
      case 'ohp_0':
        this.nowStage?.unload();
        if (!this.ajzStage) {
          this.ajzStage = new AJingziStage(this.scene);
        } else {
          this.ajzStage.reload();
        }
        this.nowStage = this.ajzStage;
        break;
      case 'ohp_1':
        this.nowStage?.unload();
        if (!this.bzzStage) {
          this.bzzStage = new BZhuanziStage(this.scene);
        } else {
          this.bzzStage.reload();
        }
        this.nowStage = this.bzzStage;
        break;
      case 'ohp_2':
        this.nowStage?.unload();
        if (!this.clhStage) {
          this.clhStage = new CLianheStage(this.scene);
        } else {
          this.clhStage.reload();
        }
        this.nowStage = this.clhStage;
        break;
      case 'ohp_3':
        this.nowStage?.unload();
        if (!this.dptStage) {
          this.dptStage = new DPentuStage(this.scene);
        } else {
          this.dptStage.reload();
        }
        this.nowStage = this.dptStage;
        break;
      case 'ohp_4':
        this.nowStage?.unload();
        if (!this.epsStage) {
          this.epsStage = new EPeisongStage(this.scene);
        } else {
          this.epsStage.reload();
        }
        this.nowStage = this.epsStage;
        break;
      case 'ohp_5':
        this.nowStage?.unload();
        if (!this.fzzStage) {
          this.fzzStage = new FZongzhuangStage(this.scene);
        } else {
          this.fzzStage.reload();
        }
        this.nowStage = this.fzzStage;
        break;
      default:
        this.nowStage?.unload();
        this.birdsEyeStage.reload();
        this.nowStage = this.birdsEyeStage;
        break;

    }
  }
  private onOpenEquipment(evt: any) {
    // 打开设备
    this.nowStage?.unload();
    if (!this.equipment) {
      this.equipment = new Equipment(this.scene);
    } else {
      this.equipment.reload();
    }
    this.nowStage = this.equipment;
    console.log("StageManager onOpenEquipment:", evt.data);
    this.equipment.open(evt.data.id, evt.data.path, evt.data.from);
  }
  private closeEquipment(evt: any) {
    // 关闭设备
    this.equipment?.unload();
    this.nowStage?.reload();
  }
}
